import { render, staticRenderFns } from "./delivered-appart-add-or-update.vue?vue&type=template&id=58cb6be2&scoped=true"
import script from "./delivered-appart-add-or-update.vue?vue&type=script&lang=js"
export * from "./delivered-appart-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./delivered-appart-add-or-update.vue?vue&type=style&index=0&id=58cb6be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cb6be2",
  null
  
)

export default component.exports